module.exports = __webpack_public_path__ + "assets/img/Bus_1.7a3cbdb3.png";